package com.applaunchkit.website.section

import androidx.compose.runtime.Composable
import com.applaunchkit.website.components.Footer
import com.applaunchkit.website.components.Header
import com.applaunchkit.website.style.StoreImageStyle
import com.applaunchkit.website.style.TextSelectionStyle
import com.applaunchkit.website.util.BackgroundGradient
import com.applaunchkit.website.util.Constants.APP_STORE_LINK
import com.applaunchkit.website.util.Constants.LATO_BOLD
import com.applaunchkit.website.util.Constants.LATO_LIGHT
import com.applaunchkit.website.util.Constants.PLAY_STORE_LINK
import com.applaunchkit.website.util.Resource
import com.applaunchkit.website.util.Theme
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.grayscale
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.filter
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun MainSection(
    breakpoint: Breakpoint,
    largeBreakpoint: Boolean,
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundImage(BackgroundGradient),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header(largeBreakpoint = largeBreakpoint)

        FirstPart(
            breakpoint = breakpoint,
            largeBreakpoint = largeBreakpoint
        )

        Surface(
            modifier = Modifier
                .height(24.px)
        ) {}

        SecondPart()

        Surface(
            modifier = Modifier
                .height(50.px)
        ) {}

        FeaturesSection(largeBreakpoint)

        Surface(
            modifier = Modifier
                .height(150.px)
        ) {}

        Footer(largeBreakpoint)

        Surface(
            modifier = Modifier
                .height(50.px)
        ) {}
    }
}

@Composable
private fun FirstPart(
    breakpoint: Breakpoint,
    largeBreakpoint: Boolean,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Surface(
            modifier = Modifier
                .height(if (largeBreakpoint) 60.px else 0.px)
        ) {}
        Row(
            modifier = Modifier
                .maxWidth(if (largeBreakpoint) 800.px else 350.px)
        ) {
            P(
                attrs = TextSelectionStyle.toModifier()
                    .margin(bottom = 0.px)
                    .color(Theme.Text.rgb) // default color
                    .fontFamily(LATO_BOLD)
                    .fontSize(if (largeBreakpoint) 4.cssRem else 2.5.cssRem)
                    .lineHeight(if (largeBreakpoint) 1.1 else 1.2)
                    .textAlign(TextAlign.Center)
                    .toAttrs()
            ) {
                Text("Stunning App ")

                Span(
                    attrs = Modifier
                        .color(Theme.Primary.rgb)
                        .toAttrs()
                ) {
                    Text("Mockups")
                }

                Text(" and Visuals for Social Media ")

                Span(
                    attrs = Modifier
                        .color(Theme.Primary.rgb)
                        .toAttrs()
                ) {
                    Text("Promotions.")
                }
            }

        }
        Surface(
            modifier = Modifier
                .height(if (largeBreakpoint) 20.px else 20.px)
        ) {}
        P(
            attrs = TextSelectionStyle.toModifier()
                .maxWidth(if (largeBreakpoint) 800.px else 400.px)
                .margin(topBottom = 0.px)
                .color(Theme.TextLowVisibility.rgb)
                .fontFamily(LATO_LIGHT)
                .fontSize(if (largeBreakpoint) 1.5.cssRem else 1.1.cssRem)
                .lineHeight(value = if (largeBreakpoint) 1.6 else 1.3)
                .textAlign(TextAlign.Center)
                .toAttrs()
        ) {
            Text(
                value = "Social Creatives Kit helps you create beautiful, professional, eye-catching visuals for promoting your app on social media and app stores. No design skills required."
            )
        }
        Surface(modifier = Modifier.height(50.px)) {}
        Row {
            Image(
                modifier = StoreImageStyle.toModifier()
                    .width(if (breakpoint <= Breakpoint.SM) 8.5.cssRem else 9.cssRem)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        window.open(url = PLAY_STORE_LINK)
                    },
                src = Resource.Icon.PLAY_STORE,
                alt = "Play Store Image"
            )
            Surface(modifier = Modifier.width(size = 20.px)) {}
            Image(
                modifier = StoreImageStyle.toModifier()
                    .width(if (breakpoint <= Breakpoint.SM) 8.5.cssRem else 9.cssRem)
                    .cursor(Cursor.Pointer)
                    .filter(grayscale(100.percent))
                    .onClick {
                        window.open(url = APP_STORE_LINK)
                    },
                src = Resource.Icon.APP_STORE,
                alt = "App Store Image"
            )
//            Tooltip(
//                modifier = Modifier
//                    .padding(
//                        topBottom = 4.px,
//                        leftRight = 12.px
//                    )
//                    .borderRadius(r = 12.px)
//                    .fontFamily(SF_PRO_REGULAR),
//                target = ElementTarget.PreviousSibling,
//                text = "Coming soon"
//            )
        }
    }
}

@Composable
private fun SecondPart() {
    Box {
        Image(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(800.px),
            src = Resource.Icon.APP_PREVIEW,
            alt = "Application Preview"
        )
    }
}